import hasLosFromPosition from '../../utils/hasLosFromPosition.js';
import { AttackType } from '@wareena/grid-battles-entity/game/codebook/attackTypes';
function getRankByEnemyDistance(position, enemyUnits, allUnits, hexProperties, rules) {
    let rank = 0;
    let isInRangeOfEnemy = false;
    let isInReachOfEnemy = false;
    for (let i = 0; i < enemyUnits.length; i += 1) {
        const enemyUnit = enemyUnits[i];
        const distance = hexProperties.getDistance(position, enemyUnit.position);
        if (enemyUnit.attackType === AttackType.Ranged &&
            distance <= enemyUnit.range &&
            hasLosFromPosition({
                range: enemyUnit.range,
                fromPosition: enemyUnit.position,
                targetPosition: position,
                allUnits,
                hexProperties,
                rules,
            })) {
            isInRangeOfEnemy = true;
        }
        if (distance <= enemyUnit.maxMovementPoints) {
            isInReachOfEnemy = true;
        }
        if (isInRangeOfEnemy && isInReachOfEnemy) {
            break;
        }
    }
    if (isInReachOfEnemy || isInRangeOfEnemy) {
        rank += 0.2;
    }
    return rank;
}
export default getRankByEnemyDistance;
